import styled from "styled-components";
import {useMediaQuery} from "react-responsive";
import {SIZES} from "@/components/constants";

const VisualSection = () => {
    const SITE_URL = process.env.NEXT_PUBLIC_UPLOAD_URL;
    const isMobile = useMediaQuery(
        { query: `(max-width: ${SIZES.MOBILE_L})` },
        undefined,
        () => false
    );

    return (
        <VisualSectionWrap>
            <VideoInner>
                <Video
                    key={isMobile ? "mo" : "pc"}
                    src={isMobile ? `${SITE_URL}/media/0326_mobile.mp4` : `${SITE_URL}/media/0326.mp4`}
                    autoPlay
                    muted
                    loop
                    playsInline
                    preload="auto"
                />
            </VideoInner>
        </VisualSectionWrap>
    );
};

// const VisualSectionWrap = styled.div`
//     position: relative;
//     width: 100%;
//     height: calc(100vh - 80px);
//     overflow: hidden;
// `;
//
// const Video = styled.video`
//     position: absolute;
//     top: 50%;
//     left: 50%;
//
//     width: 100%;
//     height: 100%;
//
//     transform: translate(-50%, -50%);
//     object-fit: cover; /* 핵심 */
//
//     pointer-events: none; /* 클릭 막기 (컨트롤 완전 제거 느낌) */
// `;




const VisualSectionWrap = styled.div`
    position: relative;
    width: 100%;
    overflow: hidden;
`;

const VideoInner = styled.div`
    position: relative;
    width: 100%;
    padding-top: 56.25%; /* 16:9 */

    @media (max-width: ${SIZES.MOBILE_L}) {
        padding-top: 177.78%;
    }
`;

const Video = styled.video`
    position: absolute;
    top: 0;
    left: 0;

    width: 100%;
    height: 100%;
    background: #000;
    pointer-events: none;
`;

export default VisualSection;